export const TOOLTIP_SURFACE = {
    backgroundColor: "var(--surface-card)",
    color: "var(--text-body)",
    border: "1px solid var(--border-hairline)",
    borderRadius: "var(--pw-radius-xl)",
    boxShadow: "var(--pw-shadow-lg)",
    fontSize: "var(--pw-text-sm)",
    lineHeight: "var(--pw-leading-relaxed)",
};

export const tooltipSurface = (maxWidth) => ({ ...TOOLTIP_SURFACE, maxWidth });

export default TOOLTIP_SURFACE;
